import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaObjectDefinition } from './TypedDefinition'

export const SchemaObjectPlugin = createSchemaPlugin(
  'Schema.Object',
  SchemaObjectDefinition
)
